/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
import Vuetify from 'vuetify';
import router from './router';
import App from './App.vue';
import store from '@/store';
import Vue from 'vue';
import ErrorAlert from '@/components/ErrorAlert';
import colors from 'vuetify/lib/util/colors';

Vue.component('error-alert', ErrorAlert);
Vue.use(Vuetify);
const vuetify = new Vuetify({
  breakpoint: {
    mobileBreakpoint: 'sm'
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: colors.amber,
        secondary: colors.shades.black,
        accent: colors.grey,
        info: colors.blueGrey,
        error: colors.red,
        success: colors.green,
        background: '#f4f4f4'
      }
    }
  }
});
new Vue({
  router,
  el: '#app',
  vuetify: vuetify,
  store,
  render: h => h(App)
});
window.axios.interceptors.response.use(
  (response) => response,
  function (error) {
    if (
      error.response &&
      [401, 419].includes(error.response.status) &&
      store.getters['user/isAuthenticated']
    ) {
      store.dispatch('user/logout');
    }
    else {
      return Promise.reject(error);
    }
  }
);